import { INTERVENTION_TYPE } from '@/types/jobs'
import type {
  InterventionType,
  JobInvoiceSummary,
  JobPaymentSummary,
} from '@/types/jobs'

type JobCollectionSource = {
  intervention_type?: InterventionType | null
  amount_to_collect: number | null
  quoteTotal?: number | null
  invoice?: Pick<JobInvoiceSummary, 'balance_due' | 'status' | 'total'> | null
  payments?: Pick<JobPaymentSummary, 'amount' | 'status'>[] | null
}

export function getJobCollectionBalance(job: JobCollectionSource) {
  const paidCents = (job.payments ?? []).reduce(
    (total, payment) =>
      payment.status === 'paid'
        ? total + Math.round(payment.amount * 100)
        : total,
    0
  )
  const quoteTotalCents =
    job.intervention_type === INTERVENTION_TYPE.visit_quote
      ? Math.max(0, Math.round((job.quoteTotal ?? 0) * 100))
      : 0
  const invoiceTotalCents = Math.max(
    0,
    Math.round((job.invoice?.total ?? 0) * 100)
  )
  const amountToCollectCents = Math.max(
    0,
    Math.round((job.amount_to_collect ?? 0) * 100)
  )
  const targetCents =
    quoteTotalCents > 0
      ? quoteTotalCents
      : invoiceTotalCents > 0
        ? invoiceTotalCents
        : amountToCollectCents
  const remainingCents =
    targetCents > 0
      ? Math.max(0, targetCents - paidCents)
      : job.invoice
        ? Math.max(0, Math.round(job.invoice.balance_due * 100))
        : 0

  return {
    paidAmount: paidCents / 100,
    targetAmount: targetCents / 100,
    remainingAmount: remainingCents / 100,
    isPaid: targetCents > 0 && paidCents + 0.5 >= targetCents,
    isPartiallyPaid:
      remainingCents > 0 &&
      (paidCents > 0 || job.invoice?.status === 'partially_paid'),
  }
}
